import { useView } from '@hooks';
import { Button, ButtonProps, Tooltip } from 'antd';
import React from 'react';

interface IProps extends Omit<ButtonProps, 'children'> {
  /** The button's name: its text on desktop, its tooltip and aria-label on mobile, where only the icon shows. */
  label: string;
  /** Why the button is not usable right now. Wins over the label as the tooltip. */
  hint?: string;
  /** Desktop keeps the text alone when false, so a button that never had an icon does not gain one. */
  desktopIcon?: boolean;
}

/**
 * A header action that is an icon on mobile, so it fits the row beside the other icon buttons
 * instead of wrapping onto a row of its own, and text on desktop.
 */
export const ResponsiveIconButton: React.FC<IProps> = ({ label, hint, icon, desktopIcon = true, ...rest }) => {
  const { isMobile } = useView();

  return (
    // The span lets a disabled button show its tooltip: a disabled antd Button has pointer-events:none.
    <Tooltip title={hint || (isMobile ? label : undefined)} placement="bottom">
      <span>
        <Button {...rest} icon={isMobile || desktopIcon ? icon : undefined} aria-label={label}>
          {isMobile ? null : label}
        </Button>
      </span>
    </Tooltip>
  );
};
